export const SET_GDC = 'SET_GDC';
export const SET_SUBJECT = 'SET_SUBJECT';
export const SET_TOPIC = 'SET_TOPIC';
export const SET_CONDITION = 'SET_CONDITION';
export const SET_AUTHORIZE = 'SET_AUTHORIZE';
export const SET_USER = 'SET_USER';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT'
export const SET_NAME = 'SET_NAME';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_AMOUNT = 'SET_AMOUNT';
export const SET_TYPE = 'SET_TYPE';
export const SET_DOA = 'SET_DOA';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_ACTION = 'SET_ACTION';
export const SET_BOOK = 'SET_BOOK';
export const SET_SEARCH_NAME = 'SET_SEARCH_NAME';
export const SET_ORG = 'SET_ORG';
export const SET_BOOK_DETAIL = 'SET_BOOK_DETAIL';
export const SET_LOADING = 'SET_LOADING';
export const SET_QUERY = 'SET_QUERY';
export const SET_SELECTED_TOPIC = 'SET_SELECTED_TOPIC';
export const SET_SELECTED_CONDITION = 'SET_SELECTED_CONDITION';
export const RESET_DOA = 'RESET_DOA';
export const SET_ROLE = 'SET_ROLE';
export const SET_ADMIN = 'SET_ADMIN';
export const SET_APPROVER = 'SET_APPROVER';
export const SET_EDITOR = 'SET_EDITOR';
export const SET_BOOK_GROUP = 'SET_BOOK_GROUP';